export default __webpack_public_path__ + "static/media/Footer_iTech_License.f04870a4.svg";